export default __webpack_public_path__ + "static/media/Low-Power_Simulation_with_IEEE_Std_1801_UPF_v18.09_Exam_600x600.69abe9d3.webp";